// extracted by mini-css-extract-plugin
export default {"root":"PasswordRestore_root__-7am7","container":"PasswordRestore_container__cK33i","header":"PasswordRestore_header__Agrtj"};